// extracted by mini-css-extract-plugin
module.exports = {"container":"Certification_container__p_zcb","p1":"Certification_p1__I1gb-","p2":"Certification_p2__nizJH"};